import { Image, ImageProps } from '@unistocks/components/basic/image';
import { useAssetImage } from '@unistocks/features/assets/hooks/use-asset-image';
import { AssetImageOptions } from '@unistocks/shared/utils/asset-utils';
import { Asset } from '@unistocks/types/asset';

export const AssetImage: React.FC<ImageProps & AssetImageOptions & { asset: Asset }> = ({
  asset,
  preferAssetImage,
  ...props
}) => {
  const assetImage = useAssetImage(asset, { preferAssetImage });

  return <Image rounded size={'$1'} source={assetImage} {...props} />;
};

AssetImage.displayName = 'AssetImage';
